import { EssityColumnProps, filterType } from "@components/shared/paginatedEssityTable/GridHelper";
import { ProductBrand, UmxPharmacyDto } from "@services/src/models";
import { Product } from "@services/src/operations";
import * as ProductBrandTypeMapper from '@services/mappers/ProductBrandType';


export const UMXPharmaciesTableColumns: EssityColumnProps<UmxPharmacyDto>[] = [
	{
		sorter: true,
		dataIndex: 'technicalCode',
		key: 'technicalCode',
		title: 'Login',
		filter: 'equals' as filterType,
		width: 120
	},
	{
		sorter: true,
		dataIndex: 'kodKom',
		key: 'kodKom',
		title: 'Kod Kom',
		filter: 'equals' as filterType,
		width: 120
	},
	{
		sorter: true,
		dataIndex: 'name',
		key: 'name',
		title: 'Name',
		filter: 'contains' as filterType,
		width: 190
	},
	{
		sorter: true,
		dataIndex: 'city',
		key: 'city',
		title: 'City',
		filter: 'contains' as filterType,
		width: 140
	},
	{
		sorter: true,
		dataIndex: 'street',
		key: 'street',
		title: 'Street',
		filter: 'contains' as filterType,
		width: 140
	},
	{
		sorter: true,
		dataIndex: 'postalCode',
		key: 'postalCode',
		title: 'Postal code',
		filter: 'contains' as filterType,
		width: 100
	},
	{
		dataIndex: 'productBrand',
		key: 'productBrand',
		title: 'Product brand',
		filter: 'enum',
		filterDictionary: ProductBrand,
		width: 100,

		enumMapper: ProductBrandTypeMapper,
		render: (value: ProductBrand) => ProductBrandTypeMapper.map(value),
	},
];
